module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-content', {
    staticClass: "page_content"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('div', {
    staticClass: "img-bg-box"
  }, [_c('div', {
    staticClass: "img1-box img-common"
  }, [(_vm.ifGot) ? _c('span', {
    staticClass: "get-now",
    on: {
      "click": _vm.getCoupon
    }
  }, [_vm._v("立即领取")]) : _c('span', {
    staticClass: "get-now"
  }, [_vm._v("已经领取")])]), _vm._v(" "), _c('div', {
    staticClass: "img2-box img-common"
  }, [_c('a', {
    staticClass: "buy-package__one buy-btn__common",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.buyPackageOne
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img3-box img-common"
  }, [_c('a', {
    staticClass: "buy-package__two buy-btn__common",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.buyPackageTwo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img4-box img-common"
  }, [_c('a', {
    staticClass: "buy-package__three buy-btn__common",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.buyPackageThree
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "buy-package__wxcard buy-btn__common",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.buyWxCard
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "buy-package__miniprogram buy-btn__common",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.buyMiniProgram
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img5-box img-common"
  }, [_c('a', {
    staticClass: "buy-btn__common buy-package__eye",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.buyPackageSmartEyes
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img6-box img-common"
  }, [_c('a', {
    staticClass: "buy-btn__common  buy-package__sms",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.buySms
    }
  })])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45c14968","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/store-christmax/index.vue
// module id = 1040
// module chunks = 2